/**
 * Component-owned styling for the Geolocation input types.
 *
 * Everything here is phone-layout work. The desktop presentations are plain Bulma (columns, level,
 * addons) and need no rules of their own; below the tablet breakpoint the full picker's action row
 * and the compact presentation's edit modal both need a different shape than Bulma's defaults give.
 */
module.exports = /*css*/`
/* --- Full picker: phone action row ---------------------------------------------------------
   Bulma's .level.is-mobile keeps the readout and the action buttons on one line. On a phone that
   squeezes the coordinates until they wrap underneath the pin, leaving the marker stranded above
   and centered. Give the readout its own full-width row (pin left, coordinates beside it) and drop
   the buttons to a second row, split evenly the way a mobile action row normally reads. */
@media screen and (max-width: 768px)
{
	.geolocation-input .geo-action-level
	{
		display: block;
	}

	.geolocation-input .geo-action-level .level-left
	{
		display: flex;
		flex-wrap: nowrap;
		align-items: center;
		justify-content: flex-start;
		min-width: 0;
		margin-bottom: 0.5rem;
	}

	.geolocation-input .geo-action-level .level-right
	{
		display: block;
		margin-left: 0;
	}

	/* Deliberately unscoped: geo-action-buttons is our own class, and the same even split is wanted
	   in both places it appears — the inline control's action row and the Edit modal's — for the
	   larger tap targets a phone needs. */
	.geo-action-buttons
	{
		display: flex;
		flex-wrap: nowrap;
		gap: 0.5rem;
	}

	/* Bulma's .buttons spaces children with margins; the flex gap owns spacing here so both
	   buttons can share the row exactly evenly. */
	.geo-action-buttons .button
	{
		flex: 1 1 0;
		min-width: 0;
		margin: 0;
	}
}

/* --- Compact presentation: full-screen edit modal on a phone -------------------------------
   The shared dialog centers itself with a translate and caps at 90vw/90vh, which on a phone leaves
   a cramped card with slivers of page around it — and the map inside wants every pixel. The class
   is added to the dialog element in onOpen, so this only ever reshapes the location editor.
   The .pict-modal-visible selector is included because the visible state re-declares transform. */
@media screen and (max-width: 768px)
{
	.pict-modal-dialog.geolocation-edit-modal,
	.pict-modal-dialog.geolocation-edit-modal.pict-modal-visible
	{
		top: 0;
		left: 0;
		width: 100vw;
		max-width: 100vw;
		height: 100vh;
		height: 100dvh;
		max-height: 100dvh;
		transform: none;
		border: none;
		border-radius: 0;
	}

	.pict-modal-dialog.geolocation-edit-modal .pict-modal-dialog-header
	{
		border-radius: 0;
	}
}
`;
